// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"35":"287c6f4c","37":"799dc37c","236":"42d28f1c","247":"4b27ca14","320":"3d02feb0","333":"00a5682b","436":"fcab0810","460":"89329e2a","473":"34834687","512":"1cd17c77","570":"58019f55","807":"414c736b","884":"338d2ffb","918":"4e2f35c5"}[chunkId] + ".js";
};